// extracted by mini-css-extract-plugin
module.exports = {"container_singleColumn":"SingleColumnLayout_container_singleColumn__bQ4zD","similarTitlesLayout":"SingleColumnLayout_similarTitlesLayout__sJeD7"};